import 'primeflex/primeflex.css';
import './assets/main.scss';

import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import primevueLocaleDeCh from '@/assets/primevue-locale-de-ch.json';
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import Eco2statPreset from './assets/primevue-preset';
import App from './App.vue';
import router from './router';
import { init as apiInit, loadAuthInfo } from './helpers/api';
import { setGlobals, setSession, useSession } from './helpers/globals';
import { storeCsrfToken } from './helpers/auth';
import { setupI18n, setupLocale } from './helpers/i18n';
import ConfirmationService from 'primevue/confirmationservice';
import FocusTrap from 'primevue/focustrap';

import '@/helpers/dayjs';

// Read VITE env variables: to be set BEFORE the build,
// either in webroot/frontend/.env[mode][.local] or override via ENV vars:
const apiRoot = import.meta.env.VITE_API_BASE;
const appRoot = import.meta.env.VITE_BASE_URL;

// we wrap the call in an async wrapper function, as we cannot have
// module-level async calls:
(async () => {
    // Pre-loading API info before we start the app
    apiInit(apiRoot, appRoot);
    const authInfo = await loadAuthInfo();
    setGlobals(authInfo?.globals || {});
    setSession({
        user: authInfo?.user || null,
        role: authInfo?.role || null,
        csrfToken: authInfo?.csrfToken || null,
        authLevel: authInfo?.authLevel || null
    });
    storeCsrfToken(useSession().csrfToken);
    const result = await setupLocale('de');
    const messages = result;

    const app = createApp(App);

    app.use(router);
    app.use(PrimeVue, {
        locale: primevueLocaleDeCh['de-ch'],
        theme: {
            preset: Eco2statPreset,
            options: {
                darkModeSelector: '.eco2stat-dark',
                cssLayer: true
            }
        },
    });
    app.use(ToastService);
    app.use(setupI18n('de', messages));

    app.use(ConfirmationService);

    app.directive('tooltip', Tooltip);
    app.directive('focustrap', FocusTrap);
    app.mount('#app');
})();
